export const timezones = {
    "GMT-11:00": "(GMT-11:00) Midway Island, Samoa",
    "GMT-10:00": "(GMT-10:00) Hawaii",
    "GMT-09:00": "(GMT-09:00) Alaska",
    "GMT-08:00": "(GMT-08:00) USA, Los Angeles, San Francisco",
    "GMT-07:00": "(GMT-07:00) Arizona, Denver, Chihuahua, 'Mountain Time'",
    "GMT-06:00": "(GMT-06:00) Mexico City, Monterrey, 'Central Time'",
    "GMT-05:00": "(GMT-05:00) Indiana, Bogota, Lima, 'Eastern Time'",
    "GMT-04:30": "(GMT-04:30) Caracas",
    "GMT-04:00": "(GMT-04:00) La Paz, Santiago,'Atlantic Time'",
    "GMT-03:30": "(GMT-03:30) Newfoundland",
    "GMT-03:00": "(GMT-03:00) Buenos Aires, Greenland",
    "GMT-02:00": "(GMT-02:00) Stanley",
    "GMT-01:00": "(GMT-01:00) Azores, Cape Verde Is.",
    GMT: "(GMT) Casablanca, Dublin, Lisbon, London, Monrovia",
    "GMT+01:00": "(GMT+01:00) Amsterdam, Berlin, Madrid, Prague, Paris",
    "GMT+02:00": "(GMT+02:00) Tallinn, Vilnius, Minsk, Helsinki",
    "GMT+03:00": "(GMT+03:00) Baghdad, Kuwait, Moscow",
    "GMT+03:30": "(GMT+03:30) Tehran",
    "GMT+04:00": "(GMT+04:00) Baku, Volgograd, Tbilisi",
    "GMT+04:30": "(GMT+04:30) Kabul",
    "GMT+05:00": "(GMT+05:00) Karachi, Tashkent",
    "GMT+05:30": "(GMT+05:30) Kolkata",
    "GMT+05:45": "(GMT+05:45) Kathmandu",
    "GMT+06:00": "(GMT+06:00) Ekaterinburg, Almaty, Dhaka",
    "GMT+07:00": "(GMT+07:00) Novosibirsk, Bangkok, Jakarta",
    "GMT+08:00": "(GMT+08:00) Krasnoyarsk, Hong Kong, Singapore",
    "GMT+09:00": "(GMT+09:00) Irkutsk, Seoul, Tokyo",
    "GMT+09:30": "(GMT+09:30) Adelaide, Darwin",
    "GMT+10:00": "(GMT+10:00) Yakutsk, Canberra, Sydney",
    "GMT+11:00": "(GMT+11:00) Vladivostok",
    "GMT+12:00": "(GMT+12:00) Magadan, Auckland, Fiji",
}

export type Timezone = keyof typeof timezones
